import { createStandaloneToast } from '@chakra-ui/react';
import { getToastId } from 'utils/apiFeedback';

const { toast } = createStandaloneToast();

export const showToast = (message, status = 'error') => {
  const toastId = getToastId(status, message);

  if (toast.isActive?.(toastId)) return;

  toast({
    id: toastId,
    title: message,
    status,
    duration: 3000,
    isClosable: true,
  });
};
